import { CookieLoader } from '@alme/storage-ts/CookieLoader';
import { getLogger } from '../../utils/DebugUtils';
import { isPeaks } from '../../platform/identifiers';
const cookieName = isPeaks() ? 'almePeaksUiState' : 'almeUiStateExt';
export class AlmeAppUtilsBase {
    constructor(almeState, setAlmeState, appConfig) {
        this.almeState = almeState;
        this.setAlmeState = setAlmeState;
        this.appConfig = appConfig;
        this.logger = getLogger(appConfig.UiLogLevel);
    }
}
const savedAppState = new CookieLoader(cookieName);
export function updateAppState(state) {
    const savedState = {
        isOpen: state.isOpen,
        lastEntryId: state.lastEntryId,
        isLoggedIn: state.isLoggedIn,
        clientSessionId: state.clientSessionId,
        accessKey: state.accessKey,
        sessionMessages: state.sessionMessages,
        customerCheckStatusMessage: state.customerCheckStatusMessage,
        sessionExpired: state.sessionExpired,
        lastActivityTime: state.lastActivityTime,
        interactionId: state.interactionId,
        currentEnterpriseId: state.currentEnterpriseId,
        wasSpanishLiveChatLinkClicked: state.wasSpanishLiveChatLinkClicked,
        isSpanishLiveChatConnected: state.isSpanishLiveChatConnected,
        chatId: state.chatId,
        liveChatCaseID: state.liveChatCaseID,
    };
    savedAppState.UpdateStorage(savedState);
}
export function clearStorage() {
    try {
        savedAppState.ClearStorage();
    }
    catch (ex) {
        console.error(ex);
    }
}
export function getCurrentAppState() {
    let appState = {
        isLoggedIn: false,
    };
    try {
        appState = savedAppState.GetStorage() || appState;
    }
    catch (ex) {
        console.error(ex);
    }
    return appState;
}
